import React from 'react'
import PropTypes from 'prop-types'

const CreditCardBack = ({ cvv, cvvMask }) => {
  return (
    <span className='back_credit-card cvv_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-1 txt-uppercase'>
      {cvv || cvvMask}
    </span>
  )
}
CreditCardBack.propTypes = {
  cvv: PropTypes.string.isRequired,
  cvvMask: PropTypes.string
}

export default CreditCardBack



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/CreditCardBack.js